import type { PageRef, RouterRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getDPCollectionId } from '../utils/getDPCollectionId'

type Params = {
  editorSdkProxy: EditorSDK
  routerRef: RouterRef
  pageRef: PageRef
  isCollectionDeleted: (collectionId: string) => Promise<boolean>
}

export const isDPCollectionDeleted = async ({
  editorSdkProxy,
  routerRef,
  pageRef,
  isCollectionDeleted,
}: Params): Promise<boolean> => {
  const collectionId = await getDPCollectionId({
    editorSdkProxy,
    routerRef,
    pageRef,
  })

  return !collectionId || isCollectionDeleted(collectionId)
}
